<template>
  <div>
    <StayOrder :showActions="false" :isOtherDbQuery="true"></StayOrder>
  </div>
</template>

<script>
import StayOrder from "../orderManage/StayOrder.vue";
export default {
  name: "otherDbQueryStayOrder",
  components: { StayOrder },
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>

<style lang="less" scoped></style>
